var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51905 15C7.28249 15 7.08253 14.8287 7.02524 14.5992C6.84264 13.8677 6.49308 13.0898 5.97656 12.2657C5.36459 11.276 4.49219 10.3581 3.35938 9.51173C2.37412 8.76705 1.38886 8.25923 0.403604 7.98833C0.170254 7.9242 0 7.71728 0 7.47527C0 7.238 0.163705 7.03346 0.391855 6.96832C1.35784 6.69251 2.28841 6.24473 3.18359 5.625C4.21224 4.90885 5.07161 4.04948 5.76172 3.04688C6.37222 2.15374 6.7913 1.27041 7.01897 0.396905C7.07861 0.168071 7.28007 0 7.51658 0C7.75568 0 7.95855 0.171793 8.01675 0.403747C8.14815 0.927405 8.3535 1.4634 8.6328 2.01172C8.9844 2.6888 9.43358 3.33984 9.98048 3.96485C10.5403 4.57682 11.1654 5.13021 11.8555 5.625C12.7573 6.26423 13.674 6.71333 14.6058 6.9723C14.8344 7.03582 15 7.23933 15 7.47656C15 7.71735 14.8294 7.92255 14.5972 7.98623C14.0066 8.14815 13.3986 8.4093 12.7735 8.76953C12.0182 9.21225 11.3151 9.73958 10.664 10.3516C10.013 10.9505 9.47918 11.582 9.06248 12.2461C8.54498 13.072 8.19503 13.8559 8.01278 14.5979C7.95623 14.8281 7.75598 15 7.51905 15Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar7);
export default __webpack_public_path__ + "static/media/star_7.ba27a6af519a6ee15f57d0db5dfd72f0.svg";
export { ForwardRef as ReactComponent };